<template>
  <div class="row">
    <div class="col-lg-12">
      <modal :show.sync="modals.infoModal" :preventClose="true">
        <div style="
            margin: -24px -24px 0px -24px;
            padding: 20px 40px 20px 40px;
            background-color: #15b0cf;
          ">
          <div class="row">
            <div class="col-lg"></div>
            <div class="col-lg-6 text-center">
              <div style="
                  text-align: center;
                  border-radius: 100%;
                  border: 10px solid white;
                ">
                <i style="
                    padding: 15px;
                    color: white;
                    font-size: 130px;
                    font-weight: 900;
                  " class="fa fa-info"></i>
              </div>
              <div>
                <p style="
                    color: white;
                    font-size: 17px;
                    text-align: center;
                    font-weight: 500;
                  ">
                  Info!
                </p>
              </div>
            </div>
            <div class="col-lg"></div>
          </div>
        </div>
        <br />
        <div class="row">
          <div class="col-lg-12 text-center">
            <p style="color: #A5A5A5">{{ message }}</p>
          </div>
        </div>
        <br />
        <div class="row">
          <div class="col-lg-12 text-center" style="margin-bottom: 30px">
            <base-button type="primary" @click="
              modals.infoModal = false;
            editDialogVisible = true;
            ">Ok</base-button>
          </div>
        </div>
      </modal>
      <StatusModal :show.sync="modals.successModal" :message="modals.success" :title="modals.successTitle" />
      <br />

      <div class="row">
        <div class="col-lg-4" style="padding-top: 2px">
          <el-select placeholder="Select service location" v-model="servicelocation" @change="getData()" filterable>
            <el-option v-for="option in servicelocations" class="select-info custom-option" :value="option.value"
              :label="option.label" :key="option.value"></el-option>
          </el-select>
        </div>
        <div class="col-lg"></div>
        <div class="col-lg-3 text-right">
          <el-input type="search" class="mb-3 search-input" prefix-icon="el-icon-search" placeholder="Search item..."
            v-model="searchQuery" aria-controls="datatables"></el-input>
        </div>
      </div>

      <!--tab content-->
      <div class="row">
        <div class="col-lg-12">
          <div class="tabs">
            <div class="tab-list" style="display: flex">
              <div v-for="(tab, index) in tabs" :key="index" :class="{
                'first-tab': index === 0,
                'last-tab': index === 1,
                'inactive-tab': activeTab !== index,
              }" @click="activeTab = index" style="z-index: 999">
                <p :class="{
                  'active-tab-title': activeTab === index,
                  'inactive-tab-title': activeTab !== index,
                }" style="align-items: center">
                  <!-- display flex -->
                  <!-- <span class="dot"
                  :style="{ width: '10px', height: '10px', 'background-color': tab.pending ? 'red' : 'transparent', 'border-radius': '50%', 'margin-right': '5px', }"></span>&nbsp;&nbsp;&nbsp; -->
                  {{ tab.name }}
                </p>
              </div>
            </div>
            <card class="card-eprf">
              <el-table :data="inventories" style="width: 100%" height="550" :header-cell-style="{
                background: 'transparent',
                color: 'gray',
              }" class="custom-table" @sort-change="headerclick">
                <!-- @sort-change="headerclick" -->
                <el-table-column :min-width="50" align="center" prop="index" label="NO">
                  <div slot-scope="scope">
                    <p style="color: #A5A5A5" class="table-content">
                      {{ scope.$index + 1 }}
                    </p>
                  </div>
                </el-table-column>
                <el-table-column label="ITEM" prop="item" minWidth="100">
                  <div slot-scope="{ row }">
                    <p style="color: #A5A5A5" class="table-content">
                      {{ row.item }}
                    </p>
                  </div>
                </el-table-column>
                <el-table-column label="DESCRIPTION" prop="description" minWidth="100">
                  <div slot-scope="{ row }">
                    <p style="color: #A5A5A5" class="table-content">
                      {{ row.description }}
                    </p>
                  </div>
                </el-table-column>
                <el-table-column label="SERVICE LOCATION" prop="servicelocationname" minWidth="120">
                  <div slot-scope="{ row }">
                    <p style="color: #A5A5A5" class="table-content">
                      {{ row.servicelocationname }}
                    </p>
                  </div>
                </el-table-column>
                <el-table-column label="QUANTITY (KG)" prop="quantity">
                  <div slot-scope="{ row }">
                    <p style="color: #A5A5A5" class="table-content">
                      {{ row.quantity }}
                    </p>
                  </div>
                </el-table-column>

                <el-table-column label="DATE CREATED" prop="datecreated" sortable>
                  <div slot-scope="{ row }">
                    <p style="color: #A5A5A5" class="table-content">
                      {{ moment(row.datecreated).format("DD MMM YYYY") }}
                    </p>
                  </div>
                </el-table-column>
                <!-- :sort-method="headerclick" -->
                <el-table-column label="LAST UPDATED" prop="lastedited" sortable>
                  <div slot-scope="{ row }">
                    <p style="color: #A5A5A5" class="table-content">
                      {{ moment(row.lastedited).format("DD MMM YYYY") }}
                    </p>
                  </div>
                </el-table-column>
                <el-table-column label="EDIT" align="center">
                  <div slot-scope="{ row }">
                    <i style="
                        color: #a5a5a5;
                        font-size: 15px;
                        font-weight: 900;
                        cursor: pointer;
                      " @click="getEdit(row)" class="tim-icons icon-pencil"></i>
                  </div>
                </el-table-column>
                <el-table-column label="VIEW LOGS" align="center">
                  <div slot-scope="{ row }">
                    <i style="
                        color: #a5a5a5;
                        font-size: 15px;
                        font-weight: 900;
                        cursor: pointer;
                      " @click="getLogs(row.wastetypeid)" class="fa fa-file"></i>
                  </div>
                </el-table-column>
              </el-table>
            </card>
            <div slot="footer" class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
              <el-select v-model="pagination.perPage" placeholder="Per page">
                <el-option class="select-primary" v-for="item in pagination.perPageOptions" :key="item" :label="item"
                  :value="item"></el-option>
              </el-select>

              <base-pagination class="pagination-no-border" v-model="pagination.currentPage"
                :per-page="pagination.perPage" :total="pagination.total"></base-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal for Edit -->
    <modal :show.sync="editDialogVisible" class="modal-eprf" centered>
      <b-card class="card text-center" style="background-color: #f5f6fa; box-shadow: none" border-variant="primary"
        header="TRANSFER" header-bg-variant="primary" header-text-variant="white">
        <template #header>
          <div class="row">
            <div class="col-lg text-left">
              <h4 class="mb-0">TRANSFER</h4>
            </div>
            <div class="col-lg-3 text-right" style="padding-bottom: 10px">
              <base-button class="btn-icon btn-cancel btn-round btn-sm" @click="editDialogVisible = false">
                <i style="
                    transform: translate(-50%, -50%);
                    color: white;
                    font-weight: 900;
                    font-size: 12px;
                  " class="tim-icons icon-simple-remove"></i>
              </base-button>
            </div>
          </div>
        </template>

        <div class="row" :model="editForm">
          <div class="col-lg-6">
            <!-- Item Name -->
            <div class="row">
              <div class="col-lg text-left">
                <p class="custom-form-title">Item Name</p>
                <input type="text" v-model="editForm.item" :class="{ 'custom-input': true }" disabled />
              </div>
            </div>
            <!-- Amount in Inventory -->
            <div class="row">
              <div class="col-lg text-left">
                <p class="custom-form-title">Total Amount (kg)</p>

                <input type="number" :min="0" v-model="editForm.amountinventory" :class="{ 'custom-input': true }"
                  disabled />
              </div>
            </div>
            <!-- Amount that can be transferred in Inventory -->
            <div class="row">
              <div class="col-lg text-left">
                <p class="custom-form-title">Available Amount (kg)</p>

                <input type="number" :min="0" v-model="editForm.availableamount" :class="{ 'custom-input': true }"
                  disabled />
              </div>
            </div>
          </div>
          <div class="col-lg-6">
            <!-- Quantity -->
            <div class="row">
              <div class="col-lg text-left">
                <p class="custom-form-title">Service Location</p>

                <el-select v-if="notavailable" class="select-info tab select-width"
                  placeholder="No available service location" v-model="editForm.servicelocation"
                  :disabled="notavailable" style="width: 90%; border-bottom: 1px solid lightgray" filterable>
                  <el-option v-for="option in selects.servicelocations" class="select-info" :value="option.value"
                    :label="option.label" :key="option.value"></el-option>
                </el-select>

                <el-select v-if="!notavailable" class="select-info tab select-width" placeholder="Select"
                  v-model="editForm.servicelocation" style="width: 90%; border-bottom: 1px solid lightgray" filterable>
                  <el-option v-for="option in selects.servicelocations" class="select-info" :value="option.value"
                    :label="option.label" :key="option.value"></el-option>
                </el-select>
              </div>
            </div>

            <!-- Amount that can be transferred in Inventory -->
            <div class="row">
              <div class="col-lg text-left">
                <p class="custom-form-title">Request Amount (kg)</p>

                <input type="number" :min="0" v-model="editForm.requestamount" :class="{ 'custom-input': true }"
                  :max="editForm.availableamount" />
              </div>
            </div>
            <div class="row" v-if="editForm.message != ''">
              <div class="col-lg text-left">
                <p style="color: #EC1B23; font-size: 10px">
                  {{ editForm.message }}
                </p>
              </div>
            </div>
            <!-- Remark -->
            <div class="row">
              <div class="col-lg text-left">
                <p class="custom-form-title">Remark</p>

                <input type="text" v-model="editForm.remark" :class="{ 'custom-input': true }" />
              </div>
            </div>
          </div>
        </div>
        <br />
        <div class="row">
          <div class="col-lg text-right">
            <base-button class="btn-danger" @click="editDialogVisible = false">Cancel</base-button>
          </div>
          <div class="col-lg text-left">
            <base-button class="btn-primary" @click="saveEdit" :disabled="dis">Save</base-button>
          </div>
        </div>
      </b-card>
    </modal>
    <!-- Modal for View -->
    <modal :show.sync="viewDialogVisible" class="modal-eprf" centered>
      <b-card class="card text-center" style="background-color: #f5f6fa; box-shadow: none" border-variant="primary"
        header="TRANSFER" header-bg-variant="primary" header-text-variant="white">
        <template #header>
          <div class="row">
            <div class="col-lg text-left">
              <h4 class="mb-0">TRANSFER HISTORY</h4>
            </div>
            <div class="col-lg-3 text-right" style="padding-bottom: 10px">
              <base-button class="btn-icon btn-cancel btn-round btn-sm" @click="viewDialogVisible = false">
                <i style="
                    transform: translate(-50%, -50%);
                    color: white;
                    font-weight: 900;
                    font-size: 12px;
                  " class="tim-icons icon-simple-remove"></i>
              </base-button>
            </div>
          </div>
        </template>
        <!-- table  -->
        <div class="row">
          <div class="col-lg">
            <el-table :data="logs" style="width: 100%" height="550" :header-cell-style="{
              background: 'transparent',
              color: 'gray',
            }" class="custom-table">
              <el-table-column label="DATE & TIME" minWidth="100">
                <div slot-scope="{ row }">
                  <p class="modal-table-content">{{ row.date }}</p>
                  <p class="modal-table-content">{{ row.time }}</p>
                </div>
              </el-table-column>
              <el-table-column label="FROM" minWidth="100">
                <div slot-scope="{ row }">
                  <p class="modal-table-content">{{ row.from }}</p>
                </div>
              </el-table-column>
              <el-table-column label="TO" minWidth="120">
                <div slot-scope="{ row }">
                  <p class="modal-table-content">{{ row.to }}</p>
                </div>
              </el-table-column>
              <el-table-column label="AMOUNT">
                <div slot-scope="{ row }">
                  <p class="modal-table-content">{{ row.amount }}</p>
                </div>
              </el-table-column>

              <el-table-column label="USER">
                <div slot-scope="{ row }">
                  <p class="modal-table-content">{{ row.user }}</p>
                </div>
              </el-table-column>
              <el-table-column label="REMARK">
                <div slot-scope="{ row }">
                  <p class="modal-table-content">{{ row.remark }}</p>
                </div>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </b-card>
    </modal>
  </div>
</template>

<script>
import { Circle8 } from "vue-loading-spinner";
import {
  Table,
  TableColumn,
  Select,
  Option,
  Dialog,
  Form,
  FormItem,
  Input,
  Button,
  Tooltip,
} from "element-ui";
import Loading from "vue-loading-overlay";
import { BasePagination, Modal } from "src/components";
import moment from "moment";
import { debounce } from "src/util/debounce";
import StatusModal from "src/components/StatusModal.vue";

export default {
  name: "Inventory",

  components: {
    StatusModal,
    Loading,
    Circle8,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Select.name]: Select,
    [Option.name]: Option,
    BasePagination,
    [Dialog.name]: Dialog,
    [Form.name]: Form,
    [FormItem.name]: FormItem,
    [Input.name]: Input,
    [Button.name]: Button,
    [Tooltip.name]: Tooltip,
    Modal,
  },
  data() {
    return {
      notavailable: false,
      itemtype: "land",
      condition: true,
      activeTab: 0,
      tabs: [
        { name: "Land", content: "Content for Tab 1", total: 0 },
        { name: "Vessel", content: "Content for Tab 2", total: 0 },
      ],
      accessid: 0,

      logs: [],
      searchQuery: "",
      inventories: [
        {
          id: 1,
          item: "Organic residue",
          description: "Output from POME processing",
          quantity: "5 MT",
          datecreated: "14 Nov 2023",
          lastedited: "14 Nov 2023",
          servicelocation: "1",
        },
      ],
      temp: [],
      pagination: {
        perPage: 10,
        currentPage: 1,
        perPageOptions: [10, 25, 50],
        total: 0,
      },
      searchedData: [],
      selects: {
        servicelocation: "",
        servicelocations: [],
      },
      servicelocation: "",
      servicelocations: [],
      editDialogVisible: false, // Controls visibility of the edit dialog
      editForm: {
        id: null,
        item: "",
        description: "",
        quantity: "",
        servicelocation: "",
        amountInventory: "10", // Example amount in inventory
        amountTransfer: "0",
        remarks: "",
      },
      viewDialogVisible: false, // Controls visibility of the view dialog
      viewForm: {
        id: null,
        item: "",
        description: "",
        quantity: "",
        servicelocation: "",
        datecreated: "",
        lastedited: "",
      },
      dis: false,
      modals: {
        infoModal: false,
        successModal: false,
        success: "",
        successTitle: "",
      },
      message: "",
    };
  },
  methods: {
    headerclick(a, b) {
      return a - b;
    },
    getServiceLocation() {
      this.servicelocations = [];

      this.$http.get(":10001/api/v1/reference/service-location").then((res) => {
        if (!res.error) {
          let response = res.message;
          console.log(response);

          for (var i = 0; i < response.length; i++) {
            let obj = {
              label: response[i].Location,
              value: response[i].ServiceLocationId,
            };

            this.servicelocations.push(obj);
          }
        }
      });
    },
    getData() {
      this.inventories = [];
      this.temp = [];
      //service_location_id=&
      this.$http
        .get(
          ":10001/api/v1/inventory?search=" +
          this.searchQuery +
          "&page_size=" +
          this.pagination.perPage +
          "&page=" +
          this.pagination.currentPage +
          "&type=" +
          this.itemtype +
          "&service_location_id=" +
          this.selects.servicelocation
        )
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);

            for (var i = 0; i < response.item.length; i++) {
              let obj = {
                inventoryid: response.item[i].inventory_id,
                wastetypeid: response.item[i].waste_type_id,
                id: response.item[i].id,
                index:
                  i +
                  1 +
                  this.pagination.perPage * (this.pagination.currentPage - 1),
                item: response.item[i].item,
                description: response.item[i].description,
                previnventoryid: response.item[i].inventory_id,
                quantity: response.item[i].quantity,
                amountinventory: response.item[i].quantity,
                availableamount: "",
                requestamount: 0,
                datecreated: response.item[i].created_at,
                lastedited: response.item[i].updated_at,
                servicelocation: response.item[i].service_location_id, // Assuming service_location_id is the key
                servicelocationname: response.item[i].location,
                remark: "",
              };

              this.inventories.push(obj);
              this.temp.push(obj);
            }

            this.pagination.total = response.paginate.total_item;
          }
        });
    },

    getEdit(data) {
      console.log(data);

      // get available service location by previous service location
      this.$http
        .get(
          ":10001/api/v1/inventory/available_location/" +
          data.servicelocation +
          "/" +
          data.wastetypeid
        )
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);

            this.editDialogVisible = true;

            // service location available
            this.selects.servicelocations = [];
            this.notavailable = true;

            if (response.length != 0) {
              for (var i = 0; i < response.length; i++) {
                if (response[i].service_location !== null) {
                  let obj = {
                    label: response[i].service_location.location,
                    value: response[i].inventory_id,
                  };
                  this.selects.servicelocations.push(obj);
                }
                this.notavailable = false;
              }
            }
            this.editForm = {
              item: data.item,
              amountinventory: response[0].quantity,
              availableamount: response[0].transferable,
              wastetypeid: response[0].waste_type.waste_type_id,
              prevservicelocation: data.previnventoryid,
              servicelocation: "",
            };

            console.log(this.editForm);
            // }
          }
        });
      //
    },
    getLogs(id) {
      this.logs = [];
      this.$http.get(":10001/api/v1/inventory/log/" + id).then((res) => {
        if (!res.error) {
          let response = res.message;
          console.log(response);

          for (var i = 0; i < response.length; i++) {
            let obj = {
              id: response[i].id,
              from: response[i].from_inventory.service_location.location,
              to: response[i].to_inventory.service_location.location,
              user: response[i].user.user_name,
              amount: response[i].amount,
              date: moment(response[i].created_at).format("YYYY-MM-DD"),
              time: moment(response[i].created_at).format("hh:mm a"),
              remark: response[i].remark,
            };
            this.logs.push(obj);
          }
          this.viewDialogVisible = true;
        }
      });
    },
    saveEdit() {
      console.log(this.editForm);
      console.log(this.editForm.servicelocation);

      if (
        this.editForm.requestamount != null &&
        this.editForm.requestamount != "" &&
        this.editForm.servicelocation != ""
      ) {
        let obj = {
          waste_type_id: this.editForm.wastetypeid,
          from_inventory_id: this.editForm.servicelocation, // masa select service location dlm popup
          to_inventory_id: this.editForm.prevservicelocation, //ni list
          amount: parseInt(this.editForm.requestamount),
          remark: this.editForm.remark,
        };

        this.$http
          .put(":10001/api/v1/inventory/transfer", obj)
          .then((res) => {
            if (!res.error) {
              let response = res.message;
              console.log(response);
              // this.modals.successTitle = "Congratul"
              this.modals.success = response;
              this.modals.successModal = true;
              this.editDialogVisible = false;
            }
          })
          .catch((err) => {
            console.log(err.response.data.message);
            this.message = err.response.data.message;
            this.modals.infoModal = true;
            this.editDialogVisible = false;
          });
      } else {
        this.message = "Request amount and service location are required!";
        this.modals.infoModal = true;
        this.editDialogVisible = false;
      }
    },
    makdia(flag, total, accessid) {
      this.accessid = accessid;
      for (var i = 0; i < this.tabs.length; i++) {
        if (flag == this.tabs[i].name) {
          this.tabs[i].total = total;
        }
      }
    },
    getDownload() { },
    getAddUser(flag) {
      if (flag == "noncontractor") {
        // active tab determine user type and path
        // land
        if (this.activeTab == 0) {
          this.$router.push("/AddUser/afes/add/add");
        }

        // vessel
        if (this.activeTab == 1) {
          this.$router.push("/AddUser/land/add/add");
        }
      } else {
        this.$router.push("/AddContractor/add/add");
      }

      // customer Sales Purchase Products
      if (this.activeTab == 5) {
        this.$router.push("/BrowseProduct");
      }
    },
  },
  created() {
    this.getData();
    this.getServiceLocation();
  },
  computed: {
    tabTitle() {
      return this.condition ? "active-tab-title" : "inactive-tab-title";
    },
    queriedData() {
      let result = this.inventories;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.inventories.length;
    },
  },
  watch: {
    activeTab() {
      console.log(this.activeTab);
      if (this.activeTab == 0) {
        this.itemtype = "land";
        this.getData();
      }
      if (this.activeTab == 1) {
        this.itemtype = "vessel";
        this.getData();
      }
    },
    "editForm.requestamount"() {
      console.log(this.editForm);
      this.dis = false;
      this.editForm.message = "";

      console.log(this.editForm.requestamount);
      console.log(this.editForm.availableamount);
      if (
        parseInt(this.editForm.requestamount) ==
        parseInt(this.editForm.availableamount)
      ) {
        this.editForm.message = "You have reach max amount";
      } else if (
        parseInt(this.editForm.requestamount) >
        parseInt(this.editForm.availableamount)
      ) {
        this.editForm.requestamount = parseInt(this.editForm.availableamount);

        this.dis = true;
      }
    },
    searchQuery: debounce(function (search) {
      this.getData();
    }, 500),
    "pagination.currentPage"() {
      this.getData();
    },
    "pagination.perPage"() {
      this.getData();
    },
  },
};
</script>
<style>
.first-tab {
  cursor: pointer;
  border-top-left-radius: 10px;
  margin-right: 3px;
  background-color: white;
  box-shadow: inset;
  width: 150px;
  padding: 5px 20px;
  border-top: 5px solid #358CCB;
}

.other-tab {
  cursor: pointer;
  margin-right: 3px;
  background-color: white;
  box-shadow: inset;
  width: 150px;
  padding: 5px 20px;
  border-top: 5px solid #358CCB;
  color: #358CCB;
}

.last-tab {
  cursor: pointer;
  border-top-right-radius: 10px;
  margin-right: 3px;
  background-color: white;
  box-shadow: inset;
  width: 180px;
  padding: 5px 20px;
  border-top: 5px solid #358CCB;
}

.inactive-tab {
  background-color: #e6e6e6;
  border: none;
  color: #A5A5A5;
}

.active-tab-title {
  color: #358CCB;
  text-align: center;
}

.inactive-tab-title {
  color: #A5A5A5;
  text-align: center;
  border-top: 5px solid transparent;
}

.legend-item {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}

.legend-circle {
  display: inline-block;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  margin-right: 8px;
}

.navbar-nav .nav-item p {
  line-height: inherit;
  margin-left: 5px;
}

.custom-input {
  padding: 5px 10px 5px 10px;
  background-color: transparent;
  border: none;
  border-bottom: 1px solid lightgray;
  outline: none;
  font-size: 16px;
  width: 100%;
}

p {
  margin-top: 10px;
  font-size: 14px;
  color: #333;
}

.custom-button {
  background-color: transparent;
  border: none;
  border-bottom: 1px solid lightgray;
}

.circle {
  width: 25px;
  height: 25px;
  border-radius: 50%;
  background-color: #358CCB;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  font-weight: bold;
}

.number {
  color: white;
}

.pie-chart-container {
  position: relative;
  width: 100%;
  /* Set width as required */
  height: 250px;
  /* Set height as required */
}

.chart-title {
  width: 100px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  color: #333;
  /* Other styling properties as needed */
}

.label {
  color: #666;
}

.label2 {
  color: #ccc;
  margin-top: -7px;
  font-size: 12px;
}

.custom-form-title {
  color: #A5A5A5 !important;
  font-size: 16px !important;
}

.modal-table-content {
  word-break: break-word;
  font-size: 16px !important;
  color: #a5a5a5 !important;
}

.table-content {
  word-break: break-word;
  /* white-space: nowrap;
overflow: hidden;
text-overflow: ellipsis; */
  color: #a5a5a5;
}
</style>
